import { faChevronDown } from "@fortawesome/pro-light-svg-icons";

import { FixedPositionedDropdown } from "src/base-components/FixedPositionedDropDown";
import { DropdownItem } from "src/design-system/Dropdown";
import { Icon } from "src/design-system/Icon";

export type ViewByType = "Feature" | "Query";

type Props = {
  selected: ViewByType;
  onSelect: (viewBy: ViewByType) => void;
};

const options = [
  {
    key: "Feature" as ViewByType,
    value: "Feature",
  },
  {
    key: "Query" as ViewByType,
    value: "Query",
  },
];

export const ViewTypeDropdown: React.FC<Props> = ({ selected, onSelect }) => {
  return (
    <FixedPositionedDropdown<string, ViewByType>
      buttonClassName="border-0 rounded-none flex gap-x-1 p-3"
      buttonDataLoc="view-type-button-dropdown"
      className="h-full border-gray-200 border-l"
      dataLoc="view-type-dropdown"
      elements={options}
      renderButtonValue={(value) => (
        <div className="flex cursor-pointer items-center gap-x-9">
          <span className="font-inter-normal-12px text-gray-700">
            View by: {value}
          </span>
          <Icon icon={faChevronDown} size="xs" />
        </div>
      )}
      renderValue={({ value, selected }) => (
        <DropdownItem
          data-loc={`view-by-${value.toLowerCase()}`}
          data-selected={selected || undefined}
        >
          <span>{`View by: ${value}`}</span>
        </DropdownItem>
      )}
      selected={selected}
      onSelect={onSelect}
    />
  );
};
